import { useId } from "react";

/** Sygnet marki. `useId` daje unikalny gradient — dwa logotypy na stronie nie kolidują. */
export function Logo({ size = 32 }: { size?: number }) {
  const gradientId = useId();

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label="VeyCue">
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#635BFF" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <path
        d="M20 20 L47 74 L74 20"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="17"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="84" cy="70" r="8.5" fill="#22D3EE" />
    </svg>
  );
}
